
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import defensiveCopy from "@/util/defensive-copy";
import { RuleGroup, Condition } from "@/types/conditions";
import { configStore, documentStore } from "@/store/store";
import {
  getConditionsThatApplyToTemplateTypes,
  getConditionsThatAreAvailableForTemplateType,
  removeEmptyRulesFromRuleGroup
} from "@/lib/conditions/conditions";

import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import IconButton from "@/components/UI/IconButton.vue";
import Dialog from "@/components/UI/Dialog.vue";
import ConditionsMatrix from "./ConditionsMatrix.vue";
import FreeModeAlertForConditionsUsed from "@/components/Subscription/FreeModeAlertForConditionsUsed.vue";

@Component({
  components: {
    FreeModeAlertForConditionsUsed,
    NiceButton,
    Icon,
    Dialog,
    IconButton,
    ConditionsMatrix
  }
})
export default class ConditionsModal extends Vue {
  @Prop()
  value!: RuleGroup[] | undefined;

  open = false;

  internalValue: RuleGroup[] = this.value ? defensiveCopy(this.value) : [];

  get conditions(): Condition[] {
    return configStore.conditions;
  }

  get availableConditions(): Condition[] {
    const availableConditions = getConditionsThatAreAvailableForTemplateType(
      this.conditions,
      this.postType
    );

    return getConditionsThatApplyToTemplateTypes(availableConditions, [
      this.postType
    ]).filter(condition => condition.supports.includes("element_display"));
  }

  get postType() {
    return (
      documentStore.document.documentMeta.templateSettingsType ||
      documentStore.document.documentMeta.postType
    );
  }

  update(newValue: RuleGroup[]) {
    this.internalValue = newValue;
  }

  clear() {
    this.update([]);
    this.saveChanges();
  }

  saveChanges() {
    this.close();
    const ruleGroupWithoutEmptyRules = removeEmptyRulesFromRuleGroup(
      this.internalValue
    );

    this.internalValue = ruleGroupWithoutEmptyRules;
    this.$emit("input", ruleGroupWithoutEmptyRules);
  }

  addFirstCondition() {
    const newRuleGroups = defensiveCopy(this.internalValue);
    newRuleGroups.push([{}]);
    this.update(newRuleGroups);
  }

  close() {
    this.open = false;
  }
}
